export function pointFromEvent(event, openedEventId, mapType) {
  if(!['field', 'plate'].includes(mapType)) return null

  const x = mapType === 'field' ? event.hit_map_coordinates?.x : event.pitch?.wrong_map_coordinates.x
  const y = mapType === 'field' ? event.hit_map_coordinates?.y : event.pitch?.wrong_map_coordinates.y
  if(!x || !y) return null

  let color;
  if(event.hit_outcome === 'palo') {
    color = 'red'
  } else if(event.hit_outcome === 'karkilyonti') {
    color = '#0BDD08'
  } else if(event.hit_outcome === 'haava') {
    color = 'yellow'
  } else {
    color = 'grey'
  }

  const isOpened = openedEventId === event.event_id
  return {
    x,
    y,
    color,
    strokeWidth: isOpened ? 2 : 1,
    strokeColor: 'black',
    size: isOpened ? 4.5 : 4,
    width: isOpened ? 4.5 : 4,
    height: isOpened ? 4.5 : 4,
    opacity: 1,
    shape: event.marked ? 'circle' : 'square',
    eventId: event.event_id,
  }
}